import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import storageService from "../services/storage.service";
import { UserPreferenceService } from "../services/userPreference.service";
import { ToastService } from "../services/toast.service";

export const ModalChangePreferences = (props: any) => {
  const [isLoading, setLoading] = useState(false);
  const [homePagePreference, setHomePagePreference] = useState(0); // Estado para o índice selecionado no select
  const { t } = useTranslation();
  const user = storageService.getUser();

  useEffect(() => {
    // Ao montar o componente, verifica se há um valor armazenado no localStorage
    const storedHomePagePreference = localStorage.getItem('homePagePreference');
    if (storedHomePagePreference) {
      setHomePagePreference(parseInt(storedHomePagePreference, 10));
    }
  }, []); // O array vazio faz com que este efeito seja executado apenas uma vez, ao montar o componente

  const handleSubmit = () => {
    // Lê o valor atualizado do estado homePagePreference
    const updatedHomePagePreference = homePagePreference;
  
    // Salva o novo valor no localStorage
    localStorage.setItem('homePagePreference', updatedHomePagePreference.toString());
  
    // Dados a serem enviados para o serviço
    const userPreferences = {
      homePagePreference: updatedHomePagePreference, // Usa o valor atualizado
      hideFilterDashboard: localStorage.getItem('hideFilterDashboard') === 'true'
    };
  
    // Chama o serviço para salvar as preferências do usuário
    //console.log("userPreferences", userPreferences);
    UserPreferenceService.insert(userPreferences)
      .then(() => {
        // Você pode adicionar lógica adicional aqui após o sucesso da inserção
        //console.log('Preferências do usuário salvas com sucesso');
        ToastService.success(t("CONFIG.HOME_PAGE_PREFERENCE"));
      })
      .catch((error) => {
        // Lógica de erro
        console.error('Erro ao salvar as preferências do usuário:', error);
      })
      .finally(() => {
        // Lógica que sempre deve ser executada, independentemente do sucesso ou falha
        setLoading(false); // Caso você tenha uma lógica de carregamento
      });
  };
  

  return (
    <Modal as={Modal.Dialog} centered show={props.show} onHide={props.close}>
      <Modal.Header>
        <Modal.Title className='h6'>{props.Title}</Modal.Title>
        <Button variant='close' aria-label='Close' onClick={props.close} />
      </Modal.Header>

      <Modal.Body>
        <div>
          <p className="fw-bold">{user.fullName}</p>
        </div>
        <Form.Select
          id="dashboardSelect"
          name="dashboardSelect"
          onChange={(e) => {
            //console.log("Valor selecionado:", e.target.value); // Adicionando o console.log
            setHomePagePreference(parseInt(e.target.value, 10));
          }}
          value={homePagePreference}
          className="mb-4"
          disabled={isLoading}
        >
          <option value={0}>{t("OPTIONS.DASHBOARD_CONTROL")}</option>
          <option value={1}>{t("OPTIONS.DASHBOARD_COLLECTION")}</option>
        </Form.Select>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="primary"
          type="submit"
          disabled={isLoading}
          onClick={handleSubmit} // Não esqueça de passar a função de handleSubmit
        >
          {isLoading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            t("BUTTON_SAVE")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
